var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dhxwList"},[_c('div',{staticClass:"mains"},[_c('div',{staticClass:"first"},[_c('div',{staticClass:"details"},[_c('div',{staticClass:"first"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.curArticle.title))]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.curArticleContent)}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a21e8d6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/app/project/LtgkDetails.vue
// module id = null
// module chunks = 